import clsx from 'clsx';

/**
 * The Atrium mark, from the brand artwork (903 × 732): a round-capped orange stroke, an amber dot and
 * two base dots. The colors are the brand's, not theme tokens; only the base dots follow the text color
 * so the mark reads on dark and light themes. public/atrium.svg is the same mark for the browser tab.
 */
export function AtriumLogo({ size = 40, className }: { size?: number; className?: string }) {
  return (
    <svg className={clsx('atrium-logo', className)} width={size} height={size} viewBox="0 0 903 732" aria-hidden>
      <path d="M491 135.6 767 596.8" stroke="#fc4f00" strokeWidth={271.2} strokeLinecap="round" />
      <circle cx={281.4} cy={347.5} r={135.6} fill="#ff691c" />
      <circle cx={135.6} cy={596.8} r={135.6} fill="currentColor" />
      <circle cx={429.5} cy={596.8} r={135.6} fill="currentColor" />
    </svg>
  );
}
